import React from 'react';

export const labelTourSteps = [
  {
    title: 'Welcome to Proton Promo!',
    description:
      'This quick guide explains how DJs receive invitations & promos from your label. Please read before getting started!'
  },
  {
    title: 'Adding New Subscribers: Emails Not Always Required',
    description:
      'You can easily add subscribers to your promo pool without needing everyone’s email address. If they’re already in Proton’s system, you can invite them with a click!'
  },
  {
    title: 'When do DJs receive your invite?',
    description: (
      <div>
        <p>
          Proton does NOT spam DJs with separate emails for every new invite & promo.
          Instead, DJs receive 1 email summary of new invitations & promos{' '}
          <strong>once per week on Thursdays</strong>.
        </p>
        <p>
          This means DJs do not instantly receive your invite after you add them as a
          subscriber. After joining, DJs can choose to receive daily or instant
          notifications if they prefer.
        </p>
      </div>
    )
  },
  {
    title: 'How are promos sent?',
    description: (
      <div>
        <p>
          Promos become available automatically to all your subscribers on the{' '}
          <strong>Beatport pre-order date</strong>.
        </p>

        <p>
          You don’t have to remember to send each promo. :) Each promo remains available
          to subscribers for 2 full weeks after their release date. This gives DJs enough
          time to respond, so they don&apos;t feel rushed before the release date.
        </p>
      </div>
    )
  },
  {
    title: 'Pro Tip: Going forward, schedule pre-orders for THURSDAY!',
    description: (
      <div>
        <p>
          Even though your promo becomes available to your subscribers on the pre-order
          date, <strong>Proton only emails DJs about new promos on Thursdays</strong>.
        </p>
        <p>
          Going forward, we{' '}
          <u>
            <strong>strongly recommend</strong>
          </u>{' '}
          scheduling your pre-orders for Thursdays, ideally 2-3 weeks in advance, to make
          sure DJs have plenty of time to review your promo.
        </p>
      </div>
    )
  },
  {
    title: 'DJ Mixes on Spotify & Apple',
    description: (
      <div>
        <p>
          When you add a DJ to your promo pool, that DJ can start featuring your music in
          their own DJ mixes on Spotify & Apple, to help you boost earnings & exposure.
        </p>

        <p>
          If you don’t want DJs featuring your music in their mixes on Spotify & Apple, do
          NOT add them to your promo pool on Proton.
        </p>
      </div>
    )
  }
];
